import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sticky-content',
    templateUrl: './sticky-content.component.html',
    styleUrls: ['./sticky-content.component.scss'],
    standalone: false
})
export class StickyContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
